<template>
  <nav class="md-layout md-alignment-center-space-between">

    <div class="block_left">

      <div v-if="!isLoggedIn" class="nav__logo">
        <logotype/>
      </div>

      <md-menu v-else class="nav__notifications"
               :md-active.sync="isNotificationCardOpen"
               md-align-trigger
               md-direction="bottom-start"
      >
        <md-button md-menu-trigger class="nav__notifications-btn" :md-ripple="false">
          <md-icon md-src="/static/img/bell.svg" :class="{ 'md-icon_active': isNotificationCardOpen }"/>
          <span class="nav__notifications-label text_large">
            <span> {{ i18n.lbl_notifications() }} </span><span class="nav__notifications-counter">({{ getUnreadMessages.length +  getUnreadErrorInc.length + getUnreadErrorOut.length + getUnreadLymit.length + getUnreadInc.length + getUnreadOut.length}})</span>
          </span>
        </md-button>
        <md-menu-content v-show="this.getUnreadMessages.length > 0 || this.getUnreadErrorOut.length > 0 || this.getUnreadErrorInc.length > 0 || this.getUnreadLymit.length > 0 || this.getUnreadInc.length > 0 || this.getUnreadOut.length > 0" class="nav__notifications-menu">
            <template v-if="this.getUnreadMessages.length > 0">
            <md-menu-item v-for="msg in this.getUnreadMessages" :key="`unread_${msg.message_key}`" class="nav__notifications-item">
              <span v-if="msg.message_key === 'transaction_income'" class="nav__notifications-content">
              {{ i18n.notification_transaction_income(msg.params) }}
              </span>
              <span v-else-if="msg.message_key === 'transaction_emission'" class="nav__notifications-content">
              {{ i18n.notification_transaction_emission(msg.params) }}
              </span>
              <span v-else-if="msg.message_key === 'transaction_exchange'" class="nav__notifications-content">
              {{ i18n.notification_transaction_exchange(msg.params) }}
              </span>
              <span v-else-if="msg.message_key === 'contract_money_lock'" class="nav__notifications-content">
              {{ i18n.notification_contract_money_lock(msg.params) }}
              </span>
              <span v-else-if="msg.message_key === 'kyc_to_not_verified'" class="nav__notifications-content">
              {{ i18n.notification_kyc_to_not_verified(msg.params) }}
              </span>
              <!--Нотиф об верефикации-->
              <span v-else-if="msg.message_key === 'kyc_approve'" class="nav__notifications-content">
              {{ i18n.notification_kyc_approve(msg.params) }}
              </span>
              <span v-else-if="msg.message_key === 'kyc_reject'" class="nav__notifications-content">
              {{ i18n.notification_kyc_reject(msg.params) }}
              </span>
              {{ checkRead(msg.id)}}
            </md-menu-item>
          </template>
          <template v-if="this.getUnreadInc.length > 0">
            <md-menu-item class="notify_aml_title"> <span class="nav__notifications-content">> {{ i18n.lbl_aml_notify_inc() }}</span></md-menu-item>
            <md-menu-item v-for="inc in this.getUnreadInc" :key="`aml_${inc.id}`" class="nav__notifications-item notify_aml" @click="openDialog(inc.id, 2)" :data-notif-id="inc.notif_id">
                <span class="nav__notifications-content">
                  &nbsp;&nbsp;&nbsp;<span class="notif-date">{{inc.timeStamp}}</span>&nbsp;{{i18n.lbl_aml_title()}}
                </span>
            </md-menu-item>
          </template>
          <template v-if="this.getUnreadOut.length > 0">
            <md-menu-item class="notify_aml_title"> <span class="nav__notifications-content">> {{ i18n.lbl_aml_notify_out() }}</span></md-menu-item>
            <md-menu-item v-for="out in this.getUnreadOut" :key="`inc_${out.id}`" class="nav__notifications-item notify_aml" @click="openDialog(out.id, 3)" :data-notif-id="out.notif_id">
                <span class="nav__notifications-content">&nbsp;&nbsp;&nbsp;<span class="notif-date">{{out.timeStamp}}</span>&nbsp;{{i18n.lbl_aml_title()}}</span>
            </md-menu-item>
          </template>
          <template v-if="this.getUnreadLymit.length > 0">
            <md-menu-item class="notify_aml_title"> <span class="nav__notifications-content">> {{ i18n.lbl_limit_title() }}</span></md-menu-item>
            <md-menu-item v-for="lymit in this.getUnreadLymit" :key="`lymit_${lymit.id}`" class="nav__notifications-item notify_aml" @click="openLymitDialog(lymit.id)" :data-notif-id="lymit.notif_id">
                <span class="nav__notifications-content">&nbsp;&nbsp;&nbsp;<span class="notif-date">{{lymit.timeStamp}}</span>&nbsp;{{i18n.lbl_limit_s()}}</span>
            </md-menu-item>
          </template>
          <template v-if="this.getUnreadErrorOut.length > 0">
            <md-menu-item class="nnotify_aml_title"> <span class="nav__notifications-content">> {{ i18n.lbl_aml_error_out() }}</span></md-menu-item>
            <md-menu-item v-for="outerror in this.getUnreadErrorOut" :key="`out_${outerror.id}`" class="nav__notifications-item notify_aml" @click="openDialog(outerror.id, -2)" :data-notif-id="outerror.notif_id"> 
              <span class="nav__notifications-content">&nbsp;&nbsp;&nbsp;<span class="notif-date">{{outerror.timeStamp}}</span>&nbsp;{{i18n.lbl_aml_title()}}</span>
            </md-menu-item>
          </template>
          <template v-if="this.getUnreadErrorInc.length > 0">
            <md-menu-item class="notify_aml_title"> <span class="nav__notifications-content">> {{ i18n.lbl_aml_error_inc() }}</span></md-menu-item>
            <md-menu-item v-for="incerror in this.getUnreadErrorInc" :key="`out_${incerror.id}`" class="nav__notifications-item notify_aml" @click="openDialog(incerror.id, -1)" :data-notif-id="incerror.notif_id"> 
              <span class="nav__notifications-content">&nbsp;&nbsp;&nbsp;<span class="notif-date">{{incerror.timeStamp}}</span>&nbsp;{{i18n.lbl_aml_title()}}</span>
            </md-menu-item>
          </template>
        </md-menu-content>
        <md-menu-content v-show="this.getUnreadMessages.length === 0 && this.getUnreadInc.length === 0 && this.getUnreadLymit.length === 0 && this.getUnreadOut.length === 0 && this.getUnreadErrorInc.length === 0 && this.getUnreadErrorOut.length === 0">
          <md-menu-item>
            <div class="nav__notifications-content">{{ i18n.notification_no_new_notifications() }}</div>
          </md-menu-item>
        </md-menu-content>
        {{ notificationMenuRefreshed() }}
      </md-menu>
    </div>

    <div class="block_center">
      <div class="nav__langs" :class="{ 'nav__langs-login' : !isLoggedIn }">
        <md-icon md-src="/static/img/globe.svg"></md-icon>
        <a href="#" @click="setLocale('ua')" :class="getUserLocale === 'ua' ? 'active' : ''" class="lang"> {{ (getUserLocale === 'ru') || (getUserLocale === 'ua') ? 'УКР' : 'UA' }} </a>
        <a href="#" @click="setLocale('en')" :class="getUserLocale === 'en' ? 'active' : ''" class="lang">EN</a>
        <a href="#" @click="setLocale('ru')" :class="getUserLocale === 'ru' ? 'active' : ''" class="lang"> {{ (getUserLocale === 'ru') || (getUserLocale === 'ua') ? 'РУС' : 'RU' }} </a>
      </div>
    </div>

    <div class="block_right">
      <div v-if="!isLoggedIn" class="nav__auth">
        <router-link class="md-button simple-link simple-link-white"
                     tag="button"
                     :md-ripple="false"
                     :to="{ name: 'signup' }"
        >{{ i18n.lbl_signup() }}</router-link>
        <router-link class="md-button simple-link simple-link-white"
                     tag="button"
                     :md-ripple="false"
                     :to="{ name: 'login' }"
        >{{ i18n.lbl_signin() }}</router-link>
        {{ notificationMenuRefreshed() }}
      </div>

      <md-menu v-else
               @click="setClipboard()"
               :md-active.sync="isUserCardOpen"
               class="nav__user"
               md-align-trigger
               md-size="huge"
               md-direction="bottom-start"
      >
        <md-button md-menu-trigger :md-ripple="false">
          <md-icon md-src="/static/img/user-2.svg"></md-icon>
          <span class="nav__user-label text_large">{{ userEmail }}</span>
        </md-button>

        <md-menu-content class="nav__user-dropdown nav-dropdown">
          <md-menu-item>

            <md-button @click="showCopySuccess"
                  class="md-icon-button"
                  id="clipboard-btn"
                  :data-clipboard-target="`#clipboard`"
            >
              <md-icon class="detail-row__clipboard-icon md-icon-size-065x">content_copy</md-icon>
            </md-button>

            <div class="nav-dropdown__info">
              <div class="nav-dropdown__email">
                <span :id="`clipboard`">{{ userEmail }}</span>
              </div>
              <p v-if="!accountBlocked" class="nav-dropdown__status">{{ `${i18n.lbl_account()} ${accountState === 'nil' ? i18n.lbl_not_verified() : i18n[accountState]() }` }}</p>
              <p v-else class="nav-dropdown__status">{{ i18n.lbl_userBlocked() }}</p>
            </div>
          </md-menu-item>
          <md-menu-item class="nav-dropdown__actions">
            <div class="btn-wrap space-between">
              <md-button @click="goSettings" class="btn btn_narrow md-primary md-yellow">{{ i18n.lbl_settings() }}</md-button>
              <md-button @click="signOut" id="btnSignout" class="btn btn_narrow md-primary">{{ i18n.lbl_signout() }}</md-button>
            </div>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
    <AmlDialog v-if="activeDialog" @close="closeDialog" :active="activeDialog" :values="activeDialogData" :account="accountId"/>
    <LymitDialog v-if="activeLymitDialog" @close="closeLymitDialog" :active="activeLymitDialog" :values="activeLymitDialogData" :account="accountId"/>
  </nav>
</template>

<script>
  import { vuexTypes } from '@vuex/types'
  import { i18n, setLangAskReload, langByCookie, setLang, getCookie, setCookie } from '@js/i18n'
  import { mapActions, mapGetters } from 'vuex'
  import { commonEvents } from '@js/events/common_events'
  import { attachEventHandler } from '@js/events/helpers'
  import { vueRoutes } from '@router/const'
  import { ACCOUNT_TYPES } from '@const'
  import Logotype from '@vue/app/common/Logotype'
  import Clipboard from 'clipboard'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import AmlDialog from './AmlDialog.vue'
  import LymitDialog from './LymitDialog.vue'

  let nextLogoutTime = ''
  const sessionTimeoutMinutes = 15
  function resetLogoutTime () {
    nextLogoutTime = Date.now() + sessionTimeoutMinutes * 60 * 1000;
  }
  let resetLogoutTimeDebug= function () {
    nextLogoutTime = Date.now() + 10 * 1000;
  }

  function doLogout () {
    document.getElementById('btnSignout').click()
  }
  function checkLogout () {
    if (nextLogoutTime === '') {
      resetLogoutTime()
    }

    let remaining = nextLogoutTime - Date.now()
    if (remaining < 0) {
      doLogout()
    }
    setTimeout(function () { checkLogout() }, 1000)

  }

  document.addEventListener('mousemove', function () { resetLogoutTime() }, false)
  document.addEventListener('keydown', function () { resetLogoutTime() }, false)
  document.addEventListener('mousedown', function () { resetLogoutTime() }, false)

  export default {
    name: 'root-navbar',

    components: { Logotype, AmlDialog, LymitDialog },

    data: () => ({
      routes: [],
      isUserCardOpen: false,
      isUserLoggedInPrevState: true,
      isNotificationCardOpen: false,
      isNotificationCardOpenPrevState: false,
      clipboard: null,
      activeDialog: false,
      activeDialogData: null,
      activeLymitDialog: false,
      activeLymitDialogData: null,
      i18n,
      ACCOUNT_TYPES,
    }),

    computed: {
      ...mapGetters({
        isLoggedIn: vuexTypes.isLoggedIn,
        userEmail: vuexTypes.userEmail,
        userType: vuexTypes.userType,
        accountState: vuexTypes.accountState,
        accountTypeI: vuexTypes.accountTypeI,
        accountBlocked: vuexTypes.accountBlocked,
        accountId: vuexTypes.accountId,
        getUnreadMessages: vuexTypes.getUnreadMessages,
        getUserLocale: vuexTypes.getUserLocale,
        getUnreadInc: 'getUnreadInc',
        getUnreadOut: 'getUnreadOut',
        getUnreadLymit: 'getUnreadLymit',
        getUnreadErrorInc: 'getUnreadErrorInc',
        getUnreadErrorOut: 'getUnreadErrorOut',
        getConnectionStatus: 'getConnectionStatus',
      }),
    },

    async created () {
      attachEventHandler(commonEvents.routesUpdateEvent, this.updateRoutes)
      this.ids = []
      if (this.isLoggedIn) {
        await this.loadLoggedInData()
      }
      if (this.isLoggedIn && !this.getConnectionStatus) {
        await this.getAMLMessages();
      }
      if (this.isLoggedIn) {
        await this.getExistMessages()
      }
      setTimeout(function () { checkLogout() }, 1000)
      await this.initLocale(this.getUserLocale)
    },
    methods: {
      ...mapActions({
          LOG_OUT: vuexTypes.LOG_OUT,
          GET_ACCOUNT_KYC_REQUESTS: vuexTypes.GET_ACCOUNT_KYC_REQUESTS,
          GET_UNREAD_MESSAGES: vuexTypes.GET_UNREAD_MESSAGES,
          MARK_READ_MESSAGES: vuexTypes.MARK_READ_MESSAGES,
          GET_USER_LOCALE: vuexTypes.GET_USER_LOCALE,
          SET_USER_LOCALE: vuexTypes.SET_USER_LOCALE,
          deleteNotificationById: 'deleteNotificationById',
          getAMLMessages: 'getAMLMessages',
          getExistMessages: 'getExistMessages',
          disconect: 'disconect',
      }),
      ...mapGetters([
        vuexTypes.getUnreadMessages,
      ]),
      openDialog (id, type) {
        if (type === 2) {
          this.activeDialogData = this.getUnreadInc.find(el => el.id === id)
        } else if (type === 3) {
          this.activeDialogData = this.getUnreadOut.find(el => el.id === id)
        } else if (type === -1) {
          this.activeDialogData = this.getUnreadErrorInc.find(el => el.id === id)
        } else if (type === -2) {
          this.activeDialogData = this.getUnreadErrorOut.find(el => el.id === id)
        }
        this.activeDialog = true
      },
      closeDialog () {
        this.activeDialog = false
        this.activeDialogData = null
      },
      openLymitDialog (id) {
        this.activeLymitDialogData = this.getUnreadLymit.find(el => el.id === id)
        this.activeLymitDialog = true
      },
      closeLymitDialog () {
        this.activeLymitDialog = false
        this.activeLymitDialogData = null
      },
      initLocale (name) {
        if (getCookie('redirectLang')) {
          this.SET_USER_LOCALE(langByCookie());
          setCookie('redirectLang', '', -1);
        } else {
          if (name === '') {
            this.SET_USER_LOCALE(langByCookie())
            return
          }
          if (langByCookie() !== name) {
            setLangAskReload(name)
          }
        }
      },

      delay(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
      },

      setLocale (name) {
          this.SET_USER_LOCALE(name)
          this.delay(500).then(() => setLangAskReload(name)); //FIXME fix this hack
      },

      updateRoutes (routes) {
        this.routes = routes
      },
      async signOut () {
        try {
          this.disconect()
        } finally {
          this.LOG_OUT()
        }
      },
      goSettings () {
        this.$router.push(vueRoutes.settings)
      },
      goTopUp () {
        this.$router.push(vueRoutes.topupBalance)
      },
      goToVerification () {
        this.$router.push(vueRoutes.verification)
      },
      checkRead(id) {
        if (this.isNotificationCardOpen && this.ids.indexOf(id) === -1) {
          this.ids.push(id)
        }
        return ""
      },
      notificationMenuRefreshed() {
        if (this.isNotificationCardOpenPrevState && !this.isNotificationCardOpen) {
          this.sendReadInfo()
        }
        if (!this.isUserLoggedInPrevState && this.isLoggedIn) {
          this.loadLoggedInData()
        }
        this.isNotificationCardOpenPrevState = this.isNotificationCardOpen
        this.isUserLoggedInPrevState = this.isLoggedIn
      },
      async loadLoggedInData() {
        await this.GET_ACCOUNT_KYC_REQUESTS()
        await this.GET_UNREAD_MESSAGES()
        await this.GET_USER_LOCALE()
      },
      sendReadInfo() {
        if (this.ids.length > 0) {
          // Send request to read endpoint
          this.MARK_READ_MESSAGES(this.ids);
          this.ids = [];
        }
      },
      showCopySuccess () {
        EventDispatcher.dispatchShowSuccessEvent(i18n.dep_copied())
      },
      setClipboard () {
        this.clipboard = new Clipboard(document.querySelector('#clipboard-btn'))
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../scss/mixins";
  @import "../../scss/variables";

  .notify_aml_title {
    font-size: 18px;
  }
  .notify_aml {
    cursor: pointer;
  }
  .notif-date {
    font-weight: bold;
  }
  nav {
    width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    @include font('main', $font-size-l, 400);

    @include respond-to(small) {
      position: relative;
    }
    & .block_left {
      flex: 2 2 auto;
    }

    & .block_center {
      flex: 0 0 auto;
    }

    & .block_right {
      flex: 0 0 auto;
      text-align: right;
    }

    .nav__notifications,
    .nav__user {
      position: relative;

      &-label {
        color: $default-white;
        font-weight: 400;
        @include respond-to(medium) {
          display: none;
        }
      }

      &-content {
        @include font('main', $font-size-m, 400);
      }

      .md-button:before {
        content: none;
      }

      /deep/ .md-ripple {
        padding: 0;
      }

      /deep/ .md-button-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .md-icon {
        position: relative;
        width: 16px;
        height: 20px;
        margin-right: 10px;

        /deep/ svg {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }

    .nav__notifications {
      &-counter {
        @include font('main', $font-size-l, 400);
        color: $yellow-push;
      }

      &-item:not(:nth-child(1)) {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 16px;
          width: calc(100% - 32px);
          height: 1px;
          background-color: rgba(0,0,0,.2);
        }
      }
    }

    .nav__langs {
      display: flex;
      padding: 0 80px;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      @include respond-to(large) {
        padding: 0 40px;
      }
      @include respond-to(medium) {
        padding: 0 12px;
      }
      @include respond-to(xsmall) {
        display: none;
      }

      .lang {
        color: $default-white;
        text-decoration: none;

        &:nth-child(2) {
          margin: 0 15px;
        }

        &:nth-child(3) {
          margin-right: 15px;
        }

        &:hover {
          color: $yellow-push;
        }

        &.active {
          color: $yellow-push;
        }
      }
    }
  }

  .nav-dropdown {
    max-width: 400px;
    max-height: unset;
    @include respond-to(small) {
      max-width: 350px;
    }

    &__info {
      width: 100%;
      margin-bottom: 8px;
      margin-left: 8px;
    }

    &__email {
      display: flex;
      font-size: $font-size-l;

      @include respond-to(medium-tablet) {
        font-size: $font-size-m;
        word-break: break-word;
      }

      & #clipboard-btn {
        cursor: pointer;

        & i {
          font-size: 20px !important;
          height: 20px;
        }
      }
    }

    &__status {
      font-size: $font-size-s;
      text-align: left;
      white-space: normal;

      @include respond-to(small) {
        text-align: center;
      }
    }
  }

</style>

<style lang="scss">
  @import "../../scss/mixins";
  @import "../../scss/variables";

  .nav__notifications {
    &-menu {
      max-width: 800px;
    }

    &-content {
      color: $col-text;
      @include font('main', $font-size-m, 400);
      white-space: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/Navbar.vue